import {LinkStyle, SITE} from 'features/ui/enums';
import * as React from 'react';
import {forwardRef} from 'react';
import {FormattedMessage} from 'react-intl';
import {getCurrentSite} from 'features/services/utils/env-helper';

import {Tag} from "features/search/types";
import {A} from '@atoms/LinksAndButtons/A';

interface Props {
    onTagClick: (tag: Tag) => void;
}

//export const PopularSearches: React.FunctionComponent<Props> = ({onTagClick}) => {
export const PopularSearches = forwardRef<HTMLAnchorElement, Props>(({onTagClick}, ref) => {
    const currentSite = getCurrentSite();

    return (
        <div className="popular-searches">
            <div className="popular-searches__category">
                <span className="popular-searches__title">
                    <FormattedMessage id="jm.components.SearchField.popularSearches"/>
                </span>

                {currentSite === SITE.SV &&
                    <>
                        <div className="popular-searches__item">
                            <A 
                                variant={LinkStyle.UNSTYLED}
                                href="#"
                                onClick={() => onTagClick({
                                    id: 'ed32ae51-bc42-e611-8139-c4346bad5070',
                                    type: 'municipality',
                                    name: 'stockholm',
                                    uniqueName: 'municipality/stockholm',
                                    url: '/stockholm-lan/stockholm-kommun/'
                                })} 
                                title='Stockholm' 
                            >Stockholm</A>
                        </div>
                        <div className="popular-searches__item">
                            <A 
                                variant={LinkStyle.UNSTYLED}
                                href="#"
                                onClick={() => onTagClick({
                                    id: 'ad33ae51-bc42-e611-8139-c4346bad5070',
                                    type: 'municipality',
                                    name: 'uppsala',
                                    uniqueName: 'municipality/uppsala',
                                    url: '/uppsala-lan/uppsala-kommun/',
                                })} 
                                title='Uppsala'
                            >Uppsala</A>
                        </div>
                        <div className="popular-searches__item">
                            <A 
                                variant={LinkStyle.UNSTYLED}
                                href="#"
                                onClick={() => onTagClick({
                                    id: '2130ae51-bc42-e611-8139-c4346bad5070',
                                    type: 'municipality',
                                    name: 'göteborg',
                                    uniqueName: 'municipality/göteborg',
                                    url: '/vastra-gotaland-lan/goteborg-kommun/',
                                })} 
                                title='Göteborg'
                            >Göteborg</A>
                        </div>
                        <div className="popular-searches__item">
                            <A 
                                variant={LinkStyle.UNSTYLED}
                                href="#"
                                ref={ref}
                                onClick={() => onTagClick({
                                    id: '7131ae51-bc42-e611-8139-c4346bad5070',
                                    type: 'municipality',
                                    name: 'malmö',
                                    uniqueName: 'municipality/malmö',
                                    url: '/skane-lan/malmo-kommun/'
                                })} 
                                title='Malmö' 
                            >Malmö</A>
                        </div>
                    </>
                }

                {currentSite === SITE.NO &&
                    <>
                        <div className="popular-searches__item">
                            <A 
                                variant={LinkStyle.UNSTYLED}
                                href="#"
                                onClick={() => onTagClick({
                                    id: "d89a6bbb-ba42-e611-8139-c4346bad5070",
                                    type: 'county',
                                    name: 'Akershus',
                                    uniqueName: 'county/akershus',
                                    url: '/akershus-fylke/'
                                })} 
                                title='Akershus'
                            >Akershus</A>
                        </div>

                        <div className="popular-searches__item">
                            <A 
                                variant={LinkStyle.UNSTYLED}
                                href="#"
                                onClick={() => onTagClick({
                                    id: "d89a6bbb-ba42-e611-8139-c4346bad5070",
                                    type: "county",
                                    name: "Vestfold",
                                    uniqueName: "county/Vestfold",
                                    url: "/vestfold-fylke/"
                                })} 
                                title='Vestfold' 
                            >Vestfold</A>
                        </div>

                        <div className="popular-searches__item">
                            <A 
                                variant={LinkStyle.UNSTYLED}
                                href="#"
                                onClick={() => onTagClick({
                                    id: "ec9a6bbb-ba42-e611-8139-c4346bad5070",
                                    type: "county",
                                    name: "Vestland",
                                    uniqueName: "county/Vestland",
                                    url: "/vestland-fylke/"
                                })} 
                                title='Vestland' 
                            >Vestland</A>
                        </div>

                        <div className="popular-searches__item">
                            <A 
                                variant={LinkStyle.UNSTYLED}
                                href="#"
                                onClick={() => onTagClick({
                                    id: "029b6bbb-ba42-e611-8139-c4346bad5070",
                                    type: "county",
                                    name: "Rogaland",
                                    uniqueName: "county/Rogaland",
                                    url: "/rogaland-fylke/"
                                })} 
                                title='Rogaland' 
                            >Rogaland</A>
                        </div>

                        <div className="popular-searches__item">
                            <A 
                                variant={LinkStyle.UNSTYLED}
                                href="#"
                                onClick={() => onTagClick({
                                    id: "1f32ae51-bc42-e611-8139-c4346bad5070",
                                    type: "municipality",
                                    name: "Oslo",
                                    uniqueName: "municipality/Oslo",
                                    url: "/oslo-fylke/oslo-kommune/"
                                })} 
                                title='Oslo' 
                            >Oslo</A>
                        </div>

                        <div className="popular-searches__item">
                            <A 
                                variant={LinkStyle.UNSTYLED}
                                href="#"
                                ref={ref}
                                onClick={() => onTagClick({
                                    id: "0c9b6bbb-ba42-e611-8139-c4346bad5070",
                                    type: "county",
                                    name: "Trøndelag",
                                    uniqueName: "county/Trøndelag",
                                    url: "/trondelag-fylke/"
                                })} 
                                title='Trøndelag' 
                            >Trøndelag</A>
                        </div>
                    </>
                }
            </div>
        </div>
    );
});
